import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import { deletedloan } from "../../../services/admin";

export default function DeletedLoan() {
  const [rows, setRows] = useState([]);

  const columnDefs = [
    { headerName: "Member", field: "member_name", sortable: true, resizable: true },
    { headerName: "Phone", field: "phone_no", sortable: true, resizable: true },
    { headerName: "Group", field: "group_name", sortable: true, resizable: true },
    { headerName: "Loan Amount", field: "loan_amount", sortable: true, resizable: true },
    {
      headerName: "Loan Date", field: "loan_date", sortable: true, resizable: true,
      cellRenderer: (p) => (p.value ? moment(p.value).format("DD-MM-YYYY") : ""),
    },
    { headerName: "Status", field: "loan_status_string", sortable: true, resizable: true },
  ];

  useEffect(() => {
    const temp = new FormData();
    // 0 means "all branches" on the backend (used when no single branch is set).
    const branch = localStorage.getItem("branch") || 0;
    deletedloan(branch, temp).then((res) => {
      if (res?.status === true) {
        setRows(res.data?.details || []);
      }
    });
  }, []);

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Deleted Loans</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><a>Loan</a></li>
          <li className="breadcrumb-item active" aria-current="page">Deleted Loans</li>
        </ol>
      </div>
      <div className="content-body">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h2 className="main-content-title tx-24 mg-b-5">Deleted Loan List</h2>
              </div>
              <div className="card-body">
                <div className="ag-theme-alpine ag-style mt-2">
                  <AgGridReact
                    columnDefs={columnDefs}
                    rowData={rows}
                    pagination="true"
                    paginationPageSize="10"
                    sortingOrder={["asc", "desc"]}
                    suppressDragLeaveHidesColumns={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
